export default {
  // node_id 56次幂
  retun_nodeid(pnode, level, sequence) {
    const obj = {
      Max: parseInt(pnode) + Math.pow(2, 56 - 7 * level) * (parseInt(sequence) + 1),
      Min: parseInt(pnode) + Math.pow(2, 56 - 7 * level) * parseInt(sequence) - 1,
    };
    return obj;
  },
  // node_id 50次幂
  retun_nodeid_50digit(pnode, level, sequence) {
    const obj = {
      Max: parseInt(pnode) + Math.pow(2, 50 - 7 * level) * (parseInt(sequence) + 1),
      Min: parseInt(pnode) + Math.pow(2, 50 - 7 * level) * parseInt(sequence) - 1,
    };
    return obj;
  },
  retun_getnodeid(pnode, level, sequence) {
    const obj = parseInt(pnode) + Math.pow(2, 50 - 7 * level) * parseInt(sequence);
    return obj;
  },
};
